import * as yup from 'yup';

const schema = yup.object({
  lat: yup.number().required(),
  lng: yup.number().required(),
});

export default schema;
